/* @flow weak */
import cx from 'classnames';
import React from 'react';
import './styles/ProgressSteps.scss';

const Dot = ({ label = null, active = false, current = false, onClick }) => {
  return (
    <div className="ProgressSteps-Step">
      {label &&
        <div
          onClick={onClick}
          className={cx('ProgressSteps-Step-Label', {
            'ProgressSteps-Step-Label-activated': active,
            'ProgressSteps-Step-Label-current': current,
            'ProgressSteps-Step-Label-link': !!onClick,
          })}>
          {label}
        </div>
      }

      <div
        onClick={onClick}
        className={cx('ProgressSteps-Step-Dot', {
          'ProgressSteps-Step-Dot-deactivated': !active && !current,
          'ProgressSteps-Step-Dot-activated': active,
          'ProgressSteps-Step-Dot-current': current,
          'ProgressSteps-Step-Dot-link': !!onClick,
        })}
      />
    </div>
  );
};
Dot.propTypes = {
  label: React.PropTypes.string,
  active: React.PropTypes.bool,
  current: React.PropTypes.bool,
  onClick: React.PropTypes.func,
};

const Line = ({ active = false }) =>
  <div
    className={cx('ProgressSteps-Line', {
      'ProgressSteps-Line-deactivated': !active,
      'ProgressSteps-Line-activated': active,
    })}
  />;
Line.propTypes = {
  active: React.PropTypes.bool,
};


const ProgressSteps = ({ labels = [], steps, current, className, onClick }) => {
  const progress = [];
  const makeClickHandler = index => {
    if ((index + 1) > current) {
      // if clicking on a dot greater than the current
      // do nothing.
      return null;
    } else {
      return onClick ? () => onClick(index) : null;
    }
  };

  for (let i = 0; i < steps - 1; i++) {
    progress.push(
      <div key={i}>
        <Dot
          label={labels[i]}
          current={i === current - 1}
          active={i < current - 1}
          onClick={makeClickHandler(i)}
        />

        <Line
          current
          active={i < current - 1}
        />
      </div>
    );
  }

  progress.push(
    <div key="end">
      <Dot
        label={labels[steps - 1]}
        current={current === steps}
        onClick={makeClickHandler(steps - 1)}
      />
    </div>
  );

  return (
    <div className={cx('ProgressSteps', className)}>
      {progress}
    </div>
  );
};

ProgressSteps.propTypes = {
  steps: React.PropTypes.number.isRequired,
  current: React.PropTypes.number.isRequired,
  className: React.PropTypes.string,
  onClick: React.PropTypes.func,
  labels: React.PropTypes.array,
};

export default ProgressSteps;



// WEBPACK FOOTER //
// ./src/components/ProgressSteps.jsx